const getScope = () => window.angular.element('[view="offer"]').scope() || window.angular.element('body').scope();

export {getScope};
